/**
 * ToDo API
 * An ASP.NET Core Web API for managing ToDo items
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface SimpleCreateRecurringJobRequestModel { 
    jobName?: string | null;
    jobId?: string | null;
    eventId?: string | null;
    startTime: string;
    endTime: string;
    technicianIds?: Array<string>;
    clientIds?: Array<string>;
    frequency: string;
    howOften: number;
    startTimeLocalTime: string;
    timeZoneId?: string;
    until?: string;
}

